import React from "react";
import CompetenceItem from "./CompetenceItem";

export default function CompetenceList(
    {
        items,
        refCompetences,
        categoryId,
        parentOrder
    } ) {
    const alreadySelectedItems = items.filter( Boolean ).map( cc => Number.parseInt( cc.id ) )
    return (
        <div className="d-flex flex-wrap gap-3 mb-2" style={ { maxWidth: '100%' } }>
            { items
                ?.sort( ( a, b ) => a.order - b.order )
                .map( competence => (
                    <CompetenceItem
                        key={ competence.order }
                        item={ competence }
                        categoryId={ categoryId }
                        parentOrder={ parentOrder }
                        numberOfItems={ items.length }
                        alreadySelectedItems={ alreadySelectedItems }
                        refCompetences={ refCompetences }
                    />
                ) ) }
        </div>
    );
}
